import React, { FC } from "react";

import {
  useBoolean,
  useFooters,
  useCounter,
  useApisMembersKaizenIdeaRepliesLikesCreate,
  useApisMembersKaizenIdeaRepliesLikesDestroy,
} from "~/hooks";

import {
  PostHeader,
  PostContent,
  KaizenIdeaRepliesLikedEmployeesModal,
} from "~/components/organisms";

import { KaizenIdeaReplyType, PostDetailMenuItemType } from "~/domains";

import { PostDetailWrapper } from "~/ui";

type PropsType = {
  kaizenIdeaReply: KaizenIdeaReplyType;
  menuItems: PostDetailMenuItemType[];
  isHighlight?: boolean;
};

export const KaizenIdeaReplyDetail: FC<PropsType> = ({
  kaizenIdeaReply,
  menuItems,
  isHighlight = false,
}: PropsType) => {
  const {
    isChecked: isLikedEmployeesModalOpen,
    setTrue: setLikedEmployeesModalOpen,
    setFalse: setLikedEmployeesModalClose,
  } = useBoolean(false);

  const {
    isChecked: liked,
    setTrue: setLiked,
    setFalse: setNotLiked,
  } = useBoolean(kaizenIdeaReply.liked);
  const {
    count: likeCount,
    increment: likeIncrement,
    decrement: likeDecrement,
  } = useCounter(kaizenIdeaReply.likesCount);

  const { mutate: likeCreateRequest } =
    useApisMembersKaizenIdeaRepliesLikesCreate();
  const { mutate: likeDeleteRequest } =
    useApisMembersKaizenIdeaRepliesLikesDestroy();

  const handleCreateLike = () => {
    likeCreateRequest(
      {
        kaizenIdeaReplyId: kaizenIdeaReply.id,
      },
      {
        onSuccess: () => {
          setLiked();
          likeIncrement();
        },
      },
    );
  };

  const handleDeleteLike = () => {
    likeDeleteRequest(
      {
        kaizenIdeaReplyId: kaizenIdeaReply.id,
      },
      {
        onSuccess: () => {
          setNotLiked();
          likeDecrement();
        },
      },
    );
  };

  const leftFooters = useFooters({
    like: {
      doneAlready: liked,
      undoOnClick: handleDeleteLike,
      doOnClick: handleCreateLike,
      textOnClick: setLikedEmployeesModalOpen,
      count: likeCount,
    },
  });

  return (
    <PostDetailWrapper isHighlight={isHighlight}>
      <PostHeader
        miniText={kaizenIdeaReply.createdAt}
        postedEmployee={kaizenIdeaReply.employee}
        menuItems={menuItems}
      />
      <PostContent
        content={kaizenIdeaReply.content}
        images={kaizenIdeaReply.attachFiles}
        footers={leftFooters.footers}
        rightFooters={[]}
        className="mt-2 pl-16"
      />
      {isLikedEmployeesModalOpen && (
        <KaizenIdeaRepliesLikedEmployeesModal
          kaizenIdeaReplyId={kaizenIdeaReply.id}
          onClose={setLikedEmployeesModalClose}
        />
      )}
    </PostDetailWrapper>
  );
};
